import React, { useState, useEffect, FC } from 'react'
import s from '@pagestyles/Blog.module.scss'
import { useTranslation } from 'react-i18next'
import getBlogcomment, {
    BlogCommentDetail,
    IBlogComment,
    IBlogCommentList
} from '@pylot-data/api/operations/get-blogcomments'
import { formatDatetime } from '@components/common/CMSBlockConst/cms-block-util'
import { useRouter } from 'next/router'

export interface BlogCommentProps {
    post_id?: string
    comments?: IBlogComment
}
const BlogComment: FC<BlogCommentProps> = (props: BlogCommentProps) => {
    const { t } = useTranslation(['blog'])
    const [defaultComments, setDefaultComments] = useState<IBlogCommentList>()
    const router = useRouter()
    const { locale } = router
    useEffect(() => {
        const getBlogRecentComment = async () => {
            if (props.post_id) {
                const blogCommentData = await getBlogcomment({
                    post_id: props.post_id,
                    locale: locale || ''
                })
                if (!blogCommentData) {
                    return {
                        notFound: true
                    }
                }
                await setDefaultComments(blogCommentData)
            }
        }
        getBlogRecentComment()
    }, [props])
    return (
        <div className={s['commentSection']}>
            {defaultComments?.blogComments &&
                defaultComments.blogComments.total_count > 0 && (
                    <>
                        <h2>
                            {t('blog||Comments')}(
                            {defaultComments?.blogComments?.total_count || 0})
                        </h2>
                        <div className={s['commentListsection']}>
                            {defaultComments?.blogComments?.items?.length &&
                                defaultComments.blogComments.items.map(
                                    (
                                        comment: BlogCommentDetail,
                                        index: number
                                    ) => {
                                        return (
                                            <div key={`comment_${index}`}>
                                                <div
                                                    className={s['commentList']}
                                                >
                                                    <h4>
                                                        {
                                                            comment.author_nickname
                                                        }
                                                    </h4>
                                                    <p>{comment.text}</p>
                                                    <strong>
                                                        {formatDatetime(
                                                            comment.update_time
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>
                                        )
                                    }
                                )}
                        </div>
                    </>
                )}
        </div>
    )
}
export default BlogComment
